const style = {
  buttonStyle: {
    display: "flex",
    gap: 16,
    justifyContent: "end",
  },
  memberOrgBox: {
    display: "flex",
    width: "100%",
    padding: "10px 24px 24px 10px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flexStart",
    gap: "16px",
    flexShrink: "0",
    borderRadius: "4px",
    background: "#F5F5F5",
    marginTop: "10px",
  },
  memberOldOrgBox: {
    display: "flex",
    width: "100%",
    padding: "24px 24px 24px 10px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flexStart",
    gap: "16px",
    flexShrink: "0",
    borderRadius: "4px",
    background: "#F5F5F5",
    marginTop: "10px",
  },
  personalDetails: {
    display: "flex",
    width: "100%",
    padding: "10px 24px 24px 10px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flexStart",
    gap: "16px",
    flexShrink: "0",
    borderRadius: "4px",
    background: "#F5F5F5",
  },
};

export default style;
